import { render, staticRenderFns } from "./service-table.vue?vue&type=template&id=256e4089&scoped=true&"
import script from "./service-table.vue?vue&type=script&lang=js&"
export * from "./service-table.vue?vue&type=script&lang=js&"
import style0 from "./service-table.vue?vue&type=style&index=0&id=256e4089&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256e4089",
  null
  
)

export default component.exports